// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"83bacca0","453":"8a6a257a","455":"415ce7dc","977":"6acb4c94"}[chunkId] + ".chunk.js";
};